export enum UpdateLikeType {
  LIKE = 'like',
  AWESOME = 'awesome',
  CURIOUS = 'curious',
  IDEA = 'idea',
  WORRIED = 'worried',
  DISLIKE = 'dislike',
}
